import React from 'react';
import { useChat } from '../../context/ChatContext';
import ChatPopup from './ChatPopup';

const ChatManager = () => {
  const { openChats, closeChat } = useChat();

  return (
    <>
      {openChats.map(chat => (
        <ChatPopup
          key={chat.eventId}
          eventId={chat.eventId}
          eventStatus={chat.eventStatus}
          onClose={() => closeChat(chat.eventId)}
          initialPosition={chat.position}
        />
      ))}
    </>
  );
};

export default ChatManager;
